// NGOProjectReport.jsx
import React from "react";

export default function NGOProjectReport() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            NGO Project Report
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            NGO Project Reports for Funding & Compliance
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks prepares NGO Project Reports for funding
            applications, government grants, CSR partnerships, and statutory
            compliance requirements.
          </p>
          <p className="text-gray-700">
            From needs assessment and logical framework development to budget
            structuring, monitoring frameworks, and donor-compliant formatting,
            comprehensive project proposals position NGOs for successful funding.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="NGO team preparing project reports for funding"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for NGO Project Reports
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks works with NGOs to compile and structure all
              essential information into comprehensive, donor-ready project
              proposals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>NGO registration documents (12A, 80G, FCRA, Society/Trust registration).</li>
                <li>
                  Project details including needs assessment, objectives,
                  target beneficiaries, activities, outcomes, and monitoring plan.
                </li>
                <li>
                  Financial estimates covering detailed budgets, funding
                  requirements, cost breakdowns, and sustainability planning.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm delivers professional NGO project documentation with
              expertise across development sectors and funding requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured and Compliant Reporting
                </h3>
                <p className="text-gray-700 text-sm">
                  Methodical project report preparation following logical
                  frameworks, donor templates, and statutory compliance standards
                  for maximum funding success.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Sector-Specific Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Specialized knowledge across education, health, environment,
                  livelihood, and women empowerment sectors with understanding
                  of major donor priorities and evaluation criteria.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from concept development and data
                  collection through professional report formatting, financial
                  modeling, and submission readiness for government, CSR, and
                  international donors.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
